// extracted by mini-css-extract-plugin
export default {"configPanel":"ControlPanel_configPanel__O0kPA","form":"ControlPanel_form__egziC"};